
 import * as React from 'react';
 import {createComponent, EventName} from '@lit/react';
 
 import {ObcNotificationMenuItem as ObcNotificationMenuItemElement} from '@oicl/openbridge-webcomponents/dist/components/notification-menu-item/notification-menu-item.js';
 
 
 

 
 export const ObcNotificationMenuItem = createComponent({
   react: React,
   tagName: 'obc-notification-menu-item',
   elementClass: ObcNotificationMenuItemElement,
   events: {
     
     onPrimaryActionClick: 'primary-action-click' as EventName<CustomEvent<void>>,
     onSecondaryActionClick: 'secondary-action-click' as EventName<CustomEvent<void>>,
     onItemClick: 'item-click' as EventName<CustomEvent<{open: boolean}>>,
   }
  });
 
 